import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import PagedEntitiesList from '../../common/components/PagedEntitiesList';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import { PaymentTypes } from './actions';
import SubscriptionStatus from './SubscriptionStatus';

const List = ({ t, reportType, ...rest }) => {
    let columns = [
        {
            header: t('FO_Payment_Id'),
            accessor: 'id',
            cell: id => `#${id}`
        },
        {
            header: t('FO_Payment_Child'),
            accessor: 'child.shortName'
        },
        {
            header: t('FO_Payment_Center'),
            accessor: 'center.name'
        },
        {
            header: t('FO_Payment_Status'),
            accessor: 'status',
            cell: (status, row) => <span>
                {t(`PaymentStatusType_${status}`)}
                {row.subscription && row.subscription.status !== 'Active' && <div className='text-muted'><SubscriptionStatus subscription={row.subscription} /></div>}
            </span>
        },
        {
            header: t('FO_Payment_Total'),
            accessor: 'total',
            cell: (total, row) => row.instalmentPlan && row.instalmentPlan.isSubscription ? t('FO_Payment_Subscription') : total
        }
    ];
    columns.push({
        header: t('FO_Payment_PaidTotal'),
		accessor: 'paidTotal',
		cell: (paidTotal, row) => row.instalmentPlan && row.instalmentPlan.isSubscription ? '' : paidTotal
    });
    columns.push({
        header: t('FO_Payment_OutstandingTotal'),
        accessor: 'outstandingTotal',
        cell: (outstandingTotal, row) => row.instalmentPlan && row.instalmentPlan.isSubscription ? '' : outstandingTotal
    });
   
    columns.push({
        header: t('FO_Payment_Created'),
        accessor: 'created',
        cell: created => moment(created).format('lll')
    });
    columns.push({
        header: t('FO_Payment_Type'),
        accessor: 'paymentKind',
        cell: (paymentKind) => {
            switch (paymentKind) {
                case PaymentTypes.Lesson: return t('FO_Payment_Type_Lesson');
                case PaymentTypes.Workshop: return t('FO_Payment_Type_Wokshop');
                case PaymentTypes.IndividualConsultation: return t('FO_Payment_Type_Consultation');
            }
        }
    });
    columns.push({
        header: '',
        accessor: 'id',
        cell: (id, payment) => <Link to={`/payment-history/${id}/${payment.paymentKind}`}>{t('FO_Payment_Details')}</Link>
    });

    columns = columns.map(column => {
        column.className = (accessor, row) => row.status === 'Pending' || row.status === 'NotApproved' ? 'bg-danger' : '';
        return column;
    });

    return (
        <div>
            <PagedEntitiesList columns={columns} {...rest} />
        </div>
    );
};

List.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
        child: PropTypes.shape({
            shortName: PropTypes.string
        }),
        center: PropTypes.shape({
            name: PropTypes.string
        }),
        startDate: PropTypes.string,
        created: PropTypes.string
    }))
};

export default withTranslation()(List);